import { createContext, type ReactNode, useContext } from 'react';

/**
 * Holds the committed (debounced) search text for the FlexiblePropertiesPage so any table under the page
 * (units now; payments, leases, inquiries next) can read it without prop drilling. The page owns the value
 * via its filters state and passes it to the provider.
 */
const FlexiblePropertiesSearchContext = createContext<string>('');

type FlexiblePropertiesSearchProviderProps = {
  searchText: string;
  children: ReactNode;
};

export const FlexiblePropertiesSearchProvider = ({ searchText, children }: FlexiblePropertiesSearchProviderProps) => (
  <FlexiblePropertiesSearchContext.Provider value={searchText}>{children}</FlexiblePropertiesSearchContext.Provider>
);

export const useFlexiblePropertiesSearch = () => useContext(FlexiblePropertiesSearchContext);
